import { render, staticRenderFns } from "./SeafarerSharedResources.vue?vue&type=template&id=5a7fcbbe"
import script from "./SeafarerSharedResources.vue?vue&type=script&lang=ts"
export * from "./SeafarerSharedResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports